export default __webpack_public_path__ + "static/media/icon_sun_active.b1879e5c.svg";